export const SET_SURVEYS = "SET_SURVEYS";
export const SET_CURRENT_SURVEY = "SET_CURRENT_SURVEY";
export const SET_QUESTION_TYPES = "SET_QUESTION_TYPES";
export const SET_SURVEY_CONFIG = "SET_SURVEY_CONFIG";
export const SET_RESPONSES = "SET_RESPONSES";
export const SET_SUMMARY = "SET_SUMMARY";
export const SET_OVERVIEW = "SET_OVERVIEW";
export const SET_BOT_CONFIG = "SET_BOT_CONFIG";
